import React, { Component } from 'react';
import '../assets/styles/About.sass';
import demoGif from'../assets/img/convert-it-all.gif';

class About extends Component {
  render() {
    return(
      <div className={`About ${ this.props.status ? 'About-show' : '' }`}>
        <h1 className="About__title">Convert it All 2.0</h1>

        <p className="About__paragraph">Unit converter app built in:</p>

        <ul className="About__list">
          <li className="About__item">React v16.5.2</li>
          <li className="About__item">Ruby on Rails v5.2.0</li>
          <li className="About__item">Sass</li>
        </ul>

        <img className="About__gif" src={demoGif} alt="Convert it All demo gif" />

        <ul className="About__list">
          <li className="About__item">Redesign of Convert it All built in pure PHP in 2013, to practice the first programming concepts on web development learnt from the course CS50 from edX.</li>
          <li className="About__item">The app was split into two, thereby, storing and displaying responsibilities are now separated. The Rails api stores the magnitudes, systems and units data and the React front-end takes care of the converting itself.</li>
          <li className="About__item">The interface has also been redesigned through React's component based architecture, allowing further responsibility grouping and code maintainability.</li>
          <li className="About__item">Deployed to Github Pages and Heroku</li>
        </ul>

</div>

    );
  }
}

export default About;
